/**
 * Instant press feedback (ui-ux U6, §7.1, §8.1): `.is-pressed` is set synchronously in `pointerdown` on every kit
 * pressable, so the pressed visual lands in the same frame. A tap on an `aria-disabled` control shakes it twice
 * (`.is-deny`) and fires the `deny` haptic. One delegated listener for the whole document. Owner: UI/Visual (F3).
 */
import { haptic } from '../feedback/haptics';

export const PRESSABLE = '.mc-btn, .mc-tile, .mc-card, .mc-tab, button.mc-roundel, .mc-pressable, .mc-seg__item, .mc-chip-filter, .mc-sealtoggle, .mc-swatch';

let installed = false;
let current: Element | null = null;

function release(): void {
  current?.classList.remove('is-pressed');
  current = null;
}

/** Installs the delegated press tracking once (idempotent). */
export function installPressTracking(doc: Document = document): void {
  if (installed) return;
  installed = true;
  doc.addEventListener('touchstart', () => { /* iOS: enables :active */ }, { passive: true });
  doc.addEventListener('pointerdown', (e) => {
    const t = (e.target as Element | null)?.closest?.(PRESSABLE);
    if (!t) return;
    if (t.getAttribute('aria-disabled') === 'true' || (t as HTMLButtonElement).disabled) {
      t.classList.remove('is-deny');
      void (t as HTMLElement).offsetWidth;          // restart the shake animation
      t.classList.add('is-deny');
      haptic('deny');
      return;
    }
    release();
    current = t;
    t.classList.add('is-pressed');
  }, { capture: true });
  for (const type of ['pointerup', 'pointercancel', 'dragstart'] as const) doc.addEventListener(type, release, { capture: true });
  doc.addEventListener('pointerleave', (e) => { if (e.target === current) release(); }, true);
  doc.addEventListener('animationend', (e) => { if (e.animationName === 'mc-deny') (e.target as Element).classList.remove('is-deny'); }, true);
}
